module.exports = __webpack_public_path__ + "img/bg-2.0477f20b.jpg";